import { createRefetchContainer, graphql } from 'react-relay';
import Contract from './ContractComponent';

export default createRefetchContainer(
  Contract,
  {
    node: graphql`
      fragment ContractContainer_node on Contract {
        id
        title
        terms
        can_edit
        deletable
        editable
        share_token
        brand_logo_url
        brand_header
        contract_event_segments(first: 99999)
          @connection(key: "ContractContainer_contract_event_segments") {
          edges {
            node {
              id
              title
              start_at
              end_at
              time_zone
              all_day
              location
              line1
              line2
              city
              province
              postal_code
              room
              notes
            }
          }
        }
        contract_line_items(first: 99999)
          @connection(key: "ContractContainer_contract_line_items") {
          edges {
            node {
              id
              description
              position
              price_cents
              price_currency
              quantity
              title
            }
          }
        }
        contract_signature_blocks(first: 99999)
          @connection(key: "ContractContainer_contract_signature_blocks") {
          edges {
            node {
              id
              address
              address_visibility
              company_name
              company_name_visibility
              email
              email_visibility
              name
              name_visibility
              phone
              phone_visibility
              signature_type
              signature_typed_name
              signature_url
              signed_at
              signer_fills_fields
              signing_party
              share_token
              title
              title_visibility
            }
          }
        }
        workspaces {
          edges {
            node {
              id
              event {
                id
                user_contacts {
                  edges {
                    node {
                      first_name
                      last_name
                      user_contact_emails {
                        edges {
                          node {
                            address
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `,
    viewer: graphql`
    fragment ContractContainer_viewer on User {
      id
      first_name
      last_name
      s_time_zone
      ...AvailabilityCalendarContainer_viewer
      ...ScheduleContainer_viewer
      primary_brand {
        id
      }
      ...LibraryContainer_viewer
    }
    `,
  },
  graphql`
    query ContractContainer_RefetchQuery($id: ID!) {
      node(id: $id) {
        ...ContractContainer_node
      }
    }
  `
);



// WEBPACK FOOTER //
// ./webpack/components/Document/Contract/ContractContainer.js